import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';


@Component({
    selector: 'app-persistent-alert',
    imports: [MatDialogModule, MatButtonModule],
    template: `
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <mat-dialog-content>
      <p>{{ data.text }}</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-raised-button color="primary" (click)="onOk()">
        {{ data.okText || 'OK' }}
      </button>
    </mat-dialog-actions>
  `,
    styles: [`
    mat-dialog-content { padding: 16px 0; }
    mat-dialog-actions { margin-top: 8px; }
  `]
})
export class PersistentAlertComponent {
  data = inject<{
    title: string;
    text: string;
    okText?: string;
}>(MAT_DIALOG_DATA);
  private dialogRef = inject<MatDialogRef<PersistentAlertComponent>>(MatDialogRef);


  onOk(): void {
    this.dialogRef.close();
  }
}
